import { Text } from '@change/ds-core-ui';

import type { TranslationKey } from '@change-corgi/core/i18n';

import { Step } from '../components/Step';

import { STEPS_CONFIG } from './constants';
import type { FullPostType } from './types';

type TranslateFn = (key: TranslationKey | string, replacements?: Record<string, unknown>) => string;

export function stepsFactory(postType: FullPostType, translate: TranslateFn) {
	const steps = STEPS_CONFIG[postType](translate);

	return (
		<section
			aria-label={translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.next_steps.aria_label')}
			className="flex w-full min-w-[250px] grow flex-col gap-4"
			data-testid="next-steps-container"
		>
			<Text className="text-size-heading-xs">
				{translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.next_steps.title')}
			</Text>
			<ol className="flex flex-col gap-4">
				{steps.map((step, index) => (
					<li key={`step-${step.variant}`} className="list-none">
						<Step
							stepLabel={translate('corgi.petition.starter_dashboard_v2.shared.sharing_modal.next_steps.step_label', {
								stepNumber: index + 1,
							})}
							label={step.label}
							variant={step.variant}
							data-testid="step-component"
						/>
					</li>
				))}
			</ol>
		</section>
	);
}
